if (!customElements.get('size-guide')) {
  customElements.define(
    'size-guide',
    class SizeGuide extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initHandlers();
      }

      initHandlers() {
        // Use event delegation on the size-guide element to handle clicks on headers
        this.addEventListener('click', (event) => {
          const sizeGuideHead = event.target.closest('.size-guide__head');
          if (!sizeGuideHead) return;

          // Remove active class from all headers within this size-guide
          this.querySelectorAll('.size-guide__head').forEach((element) => {
            element.classList.remove('active');
          });

          // Add active class to clicked header
          sizeGuideHead.classList.add('active');

          // Hide all bodies within this size-guide
          this.querySelectorAll('.size-guide__body').forEach((element) => {
            element.style.display = 'none';
          });

          // Show the target body
          const targetTable = sizeGuideHead.dataset.table;
          if (targetTable) {
            const targetBody = this.querySelector(`#${targetTable}`);
            if (targetBody) {
              targetBody.style.display = 'block';
            }
          }
        });
      }
    },
  );
}
